import {
  CustomAutoComplete,
  CustomTextField,
  renderTwoLineOption,
} from '../../common/components';
import { AUTOCOMPLETE_LISTBOX_PROPS } from '../../common/styles';
import { getProjectOptionLabel } from '../internal-orders/utils/internalOrdersUtils';
import { MATERIAL_SCOPE_TEXTS } from '../constants/materialScopeTexts';
import { toArticleOptions } from '../utils/toArticleOptions';
import { toProjectOptions } from '../utils/toProjectOptions';
import MaterialScopeFieldItem from './MaterialScopeFieldItem';

/**
 * Campos de vivienda, material y destino para sumar al filtro existente de cada pantalla de stock.
 * La vivienda restringe artículos vinculados, sin atribuirle el stock global.
 * @param {Object} props
 * @param {Object} props.options Viviendas y búsqueda de materiales (`useMaterialScopeOptions`).
 * @param {Object} props.filters Filtros vigentes.
 * @param {Function} props.onChange Recibe un evento `{ target: { name, value } }`.
 * @param {Array<string>} props.fields Campos a mostrar: `project`, `article`, `destination`.
 * @param {Object} [props.gridItemProps] Props de `Grid item` por campo, si el filtro usa `Grid`.
 * @param {Object} [props.fieldSx] Estilos de cada campo, si el filtro usa flex.
 * @returns {JSX.Element}
 */
const MaterialScopeFilters = ({
  options,
  filters,
  onChange,
  fields,
  gridItemProps,
  fieldSx = {},
}) => {
  const fieldsByKey = {
    project: (
      <CustomAutoComplete
        label={MATERIAL_SCOPE_TEXTS.project}
        name="uuid_project"
        value={filters.uuid_project || ''}
        onChange={onChange}
        options={toProjectOptions(options.projects, getProjectOptionLabel)}
        inputPlaceholder={MATERIAL_SCOPE_TEXTS.projectPlaceholder}
        noOptionsText={MATERIAL_SCOPE_TEXTS.noProjects}
        ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
        sx={fieldSx}
      />
    ),
    article: (
      <CustomAutoComplete
        label={MATERIAL_SCOPE_TEXTS.articleSearch}
        name="uuid_inventory_article"
        value={filters.uuid_inventory_article || ''}
        onChange={onChange}
        onInputChange={(_, value) => options.setSearch(value)}
        loading={options.loading}
        filterOptions={(values) => values}
        options={toArticleOptions(options.articles)}
        inputPlaceholder={MATERIAL_SCOPE_TEXTS.articlePlaceholder}
        noOptionsText={MATERIAL_SCOPE_TEXTS.noArticles}
        renderOption={renderTwoLineOption}
        ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
        sx={fieldSx}
      />
    ),
    destination: (
      <CustomTextField
        label={MATERIAL_SCOPE_TEXTS.destinationContains}
        name="destination"
        value={filters.destination || ''}
        onChange={onChange}
        fullWidth
        sx={fieldSx}
      />
    ),
  };

  return (
    <>
      {fields.map((key) => (
        <MaterialScopeFieldItem key={key} gridItemProps={gridItemProps?.[key]}>
          {fieldsByKey[key]}
        </MaterialScopeFieldItem>
      ))}
    </>
  );
};

export default MaterialScopeFilters;
